export default "__VITE_ASSET__WeyziOug__"